import {data} from './data';
import config from '../../config';
import { createToaster } from "@meforma/vue-toaster";

const getWasabiLink = async function(ext, isPublic) {
    let url;
    if(ext.charAt(0) === '/')
        ext = ext.substring(1);
    if(!isPublic) {
        const resp = await data.getSignedStorageUrl(bucketName(), ext);
        url = resp.data;
    }
    else
        url = `https://s3.${config.wasabiRegion}.wasabisys.com/${bucketName()}/${ext}`;
    return url;
}

const checkPermission = async function(fileKey) {
    const resp = await getStoragePermissions(fileKey);
    if(resp.data) {
        const grantee = resp.data.Grants.find(gr => gr.Grantee.URI && gr.Grantee.URI.includes('AllUsers') && gr.Permission === 'READ');
        return grantee ? 'public-read' : 'private';
    } else {
        return null;
    }
}

const getStoragePermissions = async function(fileKey) {
    if(fileKey.charAt(0) === '/')
        fileKey = fileKey.substring(1);
    return await data.getStorageObjectPermissions(bucketName(), fileKey);
}

const updateStoragePermissions = async function(fileKey, publicPermission, elementKey = null, onUpdate = null) {
    const toaster = createToaster({
        position: 'top-right',
        duration: 1000
    });

    if(fileKey.charAt(0) === '/')
        fileKey = fileKey.substring(1);
    const resp = await data.updateStorageObjectPermissions(bucketName(), fileKey, publicPermission);
    if(resp.success) {
        toaster.success('Saved');
        if(elementKey)
            elementKey++;
        if(onUpdate)
            onUpdate();
    } else if(resp.errors)
        toaster.error(resp.errors);
}

const bucketName = function() {
    switch(window.location.hostname) {
        case 'localhost':
        case 'admin-jv-custom-solutions-dev.herokuapp.com':
            return 'jv.development';
        case 'admin-jv-custom-solutions-qa.herokuapp.com':
            return 'jv.qa.new';
        case 'admin.jellyvisioncustom.com':
            return 'jv.production';
        default:
            return undefined;
    }
}

export const storage = {
    getWasabiLink,
    getStoragePermissions,
    updateStoragePermissions,
    checkPermission,
    bucketName
}